const extractProgressFromPageResponse = (currentPageResponse = {}) => {
  const {
    progress = { total: 0, paths: [] }
  } = currentPageResponse;

  return progress;
};

export default  extractProgressFromPageResponse;
